<style lang="scss" scoped>
@import "./radio.scss";
</style>
<template>
  <div class="slk-g-radio-wrapper">
    <div class="radio-container" :class="{ 'is-selected': isSelected, disabled: disabled }" @click="toggle">
      <div class="dot" v-if="isSelected"></div>
    </div>
    <span class="radio-label" v-if="label != ''">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "radio-view",
  props: {
    option: { type: String },
    isSelected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
};
</script>
